import { render, staticRenderFns } from "./AddMembership.vue?vue&type=template&id=b9455a84&scoped=true"
import script from "./AddMembership.vue?vue&type=script&lang=js"
export * from "./AddMembership.vue?vue&type=script&lang=js"
import style0 from "./AddMembership.vue?vue&type=style&index=0&id=b9455a84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9455a84",
  null
  
)

export default component.exports